import { render, staticRenderFns } from "./BatteryStoreLayout.vue?vue&type=template&id=0bc6b145&"
import script from "./BatteryStoreLayout.vue?vue&type=script&lang=js&"
export * from "./BatteryStoreLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc6b145')) {
      api.createRecord('0bc6b145', component.options)
    } else {
      api.reload('0bc6b145', component.options)
    }
    module.hot.accept("./BatteryStoreLayout.vue?vue&type=template&id=0bc6b145&", function () {
      api.rerender('0bc6b145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/BatteryStoreLayout.vue"
export default component.exports